import { Typography } from '@mui/material';

import { GENESIS_PRIVILEGES_LINK, HOW_TO_BUY } from './constants';
import { BackgroundCard } from './styled';

export const CitCrowdsaleWidget = () => {
  return (
    <BackgroundCard>
      <Typography textAlign="center" variant="h5" letterSpacing="0.5%" className="primary regular" mb={1.5}>
        Unlock Exclusive Access to $CIT Token Genesis Mint <br />
        <Typography variant="inherit" component="span" className="secondary regular">
          Only{' '}
          <Typography variant="inherit" component="span" className="primary semi-bold">
            0.1%
          </Typography>{' '}
          of the Total Supply Is Mintable
        </Typography>
      </Typography>
      <Typography
        component="a"
        href={GENESIS_PRIVILEGES_LINK}
        referrerPolicy="no-referrer"
        rel="noreferrer"
        target="_blank"
        className="secondary regular"
        sx={{
          textDecoration: 'underline',
          mb: 1.5,
        }}
      >
        Genesis Holder Privileges
      </Typography>
      <Typography
        component="a"
        href={HOW_TO_BUY}
        referrerPolicy="no-referrer"
        rel="noreferrer"
        target="_blank"
        className="secondary regular"
        sx={{
          textDecoration: 'underline',
          margin: '0 auto',
        }}
      >
        How to BUY $CIT?
      </Typography>
    </BackgroundCard>
  );
};
